import {
  CoveragePlanCard,
  CoveragePlanCardUrl,
  CoveragePlanSummary,
  CoveragePlanType
} from '@cms-max/medicare-api-sdk'
import { parse } from 'date-fns'
import { useMemo } from 'react'

type OmCombined = {
  partAEffectiveDate: string
  partBEffectiveDate: string
  urls: Array<CoveragePlanCardUrl>
}

type useCombinedPartAPartBArgs = {
  summary?: CoveragePlanSummary
  plans?: Array<CoveragePlanCard>
}
export function useCombinedPartAPartB ({
  summary,
  plans
}: useCombinedPartAPartBArgs) {
  return useMemo(() => {
    if (!summary || !plans?.length) return null

    const {
      hasPartA,
      hasPartB,
      isImmunosuppressiveDrugCoverage,
      isMedicareAdvantage
    } = summary

    // If user has MA or doesn't have both Part A & Part B, we can skip the rest
    if (
      isMedicareAdvantage ||
      isImmunosuppressiveDrugCoverage ||
      !(hasPartA && hasPartB)
    ) {
      return null
    }

    const combined: OmCombined = {
      partAEffectiveDate: '',
      partBEffectiveDate: '',
      urls: []
    }
    plans.forEach((plan) => {
      // enrollment_effective_date comes in as ISO8601 YYYY-MM-DD
      const enrollentDate = parse(
        plan.enrollment_effective_date,
        'yyyy-MM-dd',
        new Date()
      )
      if (plan.type === CoveragePlanType.OmPartA) {
        combined.partAEffectiveDate = new Intl.DateTimeFormat('en-US').format(
          enrollentDate
        )
      }

      if (plan.type === CoveragePlanType.OmPartB) {
        combined.partBEffectiveDate = new Intl.DateTimeFormat('en-US').format(
          enrollentDate
        )
      }

      // The URLs will be the same for both Part A & Part B, so just set from last
      if (
        [CoveragePlanType.OmPartA, CoveragePlanType.OmPartB].includes(plan.type)
      ) {
        combined.urls = plan.urls
      }
    })
    return combined
  }, [summary, plans])
}
